import * as PolicyActionTypes from '../actions/policies';
import initialState from './initialState';

import { errorResponseHandler } from '../utils/error-utils';

export default (state = initialState.policies, action) => {
  const { payload, type } = action;

  switch (type) {
    case PolicyActionTypes.LIST_UPLOADED_POLICIES:
    case PolicyActionTypes.LIST_UPLOADED_POLICIES_PENDING:
      return { ...state, uploaded_policies_loading: true };

    case PolicyActionTypes.LIST_UPLOADED_POLICIES_REJECTED:
      return {
        ...state,
        uploaded_policies_loading: false,
        error: payload.error,
        errorMessage: payload.response
      };

    case PolicyActionTypes.LIST_UPLOADED_POLICIES_FULFILLED:
      return {
        ...state,
        uploaded_policies_loading: false,
        uploaded_policies: payload.data
      };

    case PolicyActionTypes.FETCH_POLICIES:
    case PolicyActionTypes.FETCH_POLICIES_PENDING:
      return { ...state, policies_loading: true, filteredPolicies: [] };

    case PolicyActionTypes.FETCH_POLICIES_REJECTED:
      return {
        ...state,
        policies_loading: true,
        error: true,
        ...errorResponseHandler(payload, 'FetchPolicies')
      };

    case PolicyActionTypes.FETCH_POLICIES_FULFILLED:
      return {
        ...state,
        policies_loading: false,
        filteredPolicies: payload.data
      };

    case PolicyActionTypes.UPLOAD_POLICIES_PENDING:
      return {
        ...state,
        uploadError: false,
        uploading: true,
        uploadSuccess: false
      };

    case PolicyActionTypes.UPLOAD_POLICIES_REJECTED:
      return {
        ...state,
        uploadError: true,
        uploading: false,
        uploadSuccess: false,
        errorMessage: payload.data.info
      };

    case PolicyActionTypes.UPLOAD_POLICIES_FULFILLED:
      return {
        ...state,
        uploadError: false,
        uploading: false,
        uploadSuccess: true,
        successMessage: payload.data.info || payload.data.detail
      };

    case PolicyActionTypes.LIST_QUOTE_GOODS:
    case PolicyActionTypes.LIST_QUOTE_GOODS_PENDING:
      return { ...state, quote_goods_loading: true };

    case PolicyActionTypes.LIST_QUOTE_GOODS_REJECTED:
      return {
        ...state,
        quote_goods_loading: false,
        error: payload.error,
        errorMessage: payload.response.data
      };

    case PolicyActionTypes.LIST_QUOTE_GOODS_FULFILLED:
      return {
        ...state,
        quote_goods_loading: false,
        quote_goods: payload.data
      };

    case PolicyActionTypes.FETCH_PENDING_POLICIES:
    case PolicyActionTypes.FETCH_PENDING_POLICIES_PENDING:
      return { ...state, pending_policies_loading: true };

    case PolicyActionTypes.FETCH_PENDING_POLICIES_REJECTED:
      return {
        ...state,
        pending_policies_loading: false,
        error: payload.error,
        errorMessage: payload.response.data
      };

    case PolicyActionTypes.FETCH_PENDING_POLICIES_FULFILLED:
      return {
        ...state,
        pending_policies_loading: false,
        pending_policies: payload.data
      };

    case PolicyActionTypes.FETCH_QUOTES:
    case PolicyActionTypes.FETCH_QUOTES_PENDING:
      return { ...state, quotes_loading: true };

    case PolicyActionTypes.FETCH_QUOTES_REJECTED:
      return {
        ...state,
        quotes_loading: false,
        error: true,
        errorMessage: payload.data
      };

    case PolicyActionTypes.FETCH_QUOTES_FULFILLED:
      return {
        ...state,
        quotes_loading: false,
        quotes_success: true,
        quotes: payload.data
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/policies.js